import * as ProtoPokerRoom from "./proto/proto_poker_room";
import * as ProtoPokerLogin from "./proto/proto_poker_login";
import NetMsgDataToBuffer from "../../../framework/net/net_msgdata_to_buffer";

// enum {

// }

export default class NetMsgDataTableBase extends NetMsgDataToBuffer {
    //发送命令名|发送结构体|收包命令|收包结构体|协议类型:"Room."为登录服，2为麻将游戏服，3为Skynet扑克服

    // 托管通知
    static IntrustNotify: any[] = [null, null, "Room.IntrustNotify", ProtoPokerRoom.Room.IntrustNotify, 3]
    // 踢人广播
    static KickPlayerBroadcast: any[] = [null, null, "Room.KickPlayerBroadcast", ProtoPokerRoom.Room.KickPlayerBroadcast, 3]
    // 进入房间通知
    static EnterRoomNotify: any[] = [null, null, "Room.EnterBroadcast", ProtoPokerRoom.Room.EnterBroadcast, 3]
    // 准备通知
    static ReadyNotify: any[] = [null, null, "Room.ReadyBroadcast", ProtoPokerRoom.Room.ReadyBroadcast, 3]
    // 开始通知
    static StartNotify: any[] = [null, null, "Room.StartBroadcast", ProtoPokerRoom.Room.StartBroadcast, 3]
    // 重置通知
    static ResetNotify: any[] = [null, null, "Room.ResetBroadcast", ProtoPokerRoom.Room.ResetBroadcast, 3]
    // 离开通知
    static LeaveNotify: any[] = [null, null, "Room.LeaveBroadcast", ProtoPokerRoom.Room.LeaveBroadcast, 3]
    // 聊天通知
    static ChatNotify: any[] = [null, null, "Room.ChatMsgBroadcast", ProtoPokerRoom.Room.ChatMsgBroadcast, 3]
    // 解散房间请求通知
    static FreeRoomRequestNotify: any[] = [null, null, "Room.FreeBroadcast", ProtoPokerRoom.Room.FreeBroadcast, 3]
    // 房间解散通知
    static FreeRoomNotify: any[] = [null, null, "Room.FreeSuccessBroadcast", ProtoPokerRoom.Room.FreeSuccessBroadcast, 3]
    // 断线重连通知
    static ReconnNotify: any[] = [null, null, "Room.ReconnBroadcast", ProtoPokerRoom.Room.ReconnBroadcast, 3]
    // 掉线通知
    static DisconnNotify: any[] = [null, null, "Room.DisconnBroadcast", ProtoPokerRoom.Room.DisconnBroadcast, 3]
    // CustomInfo通知
    static CustomInfoNotify: any[] = [null, null, "Room.CustomInfoChangeBroadcast", ProtoPokerRoom.Room.CustomInfoChangeBroadcast, 3]
    // 金币场金币变通知
    static OneShotSettleNotify: any[] = [null, null, "Room.OneShotSettleNotify", ProtoPokerRoom.Room.OneShotSettleNotify, 3]
    // --补充金币通知
    static RechargeNotify: any[] = [null, null, "Room.RechargeNotify", ProtoPokerRoom.Room.RechargeNotify, 3]
    // // 破产通知
    // static BankruptNotify: any[] = [null, null, "Room.BankruptNotify", ProtoPokerRoom.Room.BankruptNotify, 3]
    // //倒计时时间
    // static TimeoutNotify: any[] = [null, null, "Room.TimeoutNotify", ProtoPokerRoom.Room.TimeoutNotify, 3]

    // 踢人请求
    static KickPlayer: any[] = ["Room.KickPlayerReq", ProtoPokerRoom.Room.KickPlayerReq, "Room.KickPlayerRsp", ProtoPokerRoom.Room.KickPlayerRsp, 3]
    // 托管请求
    static Intrust: any[] = ["Room.IntrustReq", ProtoPokerRoom.Room.IntrustReq, "Room.IntrustRsp", ProtoPokerRoom.Room.IntrustRsp, 3]
    // 请求更新余额
    static UserCoinBalance: any[] = ["Room.UserCoinBalanceReq", ProtoPokerRoom.Room.UserCoinBalanceReq, "", null, 3]
    // 进入房间
    static EnterRoom: any[] = ["Room.EnterReq", ProtoPokerRoom.Room.EnterReq, "Room.EnterRsp", ProtoPokerRoom.Room.EnterRsp, 3]
    // 准备
    static Ready: any[] = ["Room.ReadyReq", ProtoPokerRoom.Room.ReadyReq, "Room.ReadyRsp", ProtoPokerRoom.Room.ReadyRsp, 3]
    // 开始
    static Start: any[] = ["Room.StartReq", ProtoPokerRoom.Room.StartReq, "Room.StartRsp", ProtoPokerRoom.Room.StartRsp, 3]
    // 离开
    static Leave: any[] = ["Room.LeaveReq", ProtoPokerRoom.Room.LeaveReq, "Room.LeaveRsp", ProtoPokerRoom.Room.LeaveRsp, 3]
    // 聊天
    static Chat: any[] = ["Room.ChatMsgReq", ProtoPokerRoom.Room.ChatMsgReq, "Room.ChatMsgRsp", ProtoPokerRoom.Room.ChatMsgRsp, 3]
    // 解散房间
    static FreeRoom: any[] = ["Room.FreeReq", ProtoPokerRoom.Room.FreeReq, "Room.FreeRsp", ProtoPokerRoom.Room.FreeRsp, 3]
    // CustomInfo
    static CustomInfo: any[] = ["Room.CustomInfoChangeReq", ProtoPokerRoom.Room.CustomInfoChangeReq, "Room.CustomInfoChangeRsp", ProtoPokerRoom.Room.CustomInfoChangeRsp, 3]
    // --请求补充金币
    static UserRecharge: any[] = ["Room.RechargeRet", ProtoPokerRoom.Room.RechargeReq, "", null, 3]
    // //告诉其他人我充值的结果 0 已经充值重新检查破产状态  3告诉别人我的充值结果 确认破产
    // static BankruptConfirmReq: any[] = ["Room.BankruptConfirmReq", ProtoPokerRoom.Room.BankruptConfirmReq, "", null, 3]

    // 请求登录
    static Login: any[] = ["Login.LoginReq", ProtoPokerLogin.Login.LoginReq, "Login.LoginRsp", ProtoPokerLogin.Login.LoginRsp, 3]
    // 心跳包
    static Ping: any[] = ["Login.PingReq", ProtoPokerLogin.Login.PingReq, "Login.PingRsp", ProtoPokerLogin.Login.PingRsp, 3]

    static UserCoinBalanceNotify: any[] = [null, null, "Room.UserCoinBalanceNotify", ProtoPokerRoom.Room.UserCoinBalanceNotify, 3]
    static BatchCoinBalanceNotify: any[] = [null, null, "Room.BatchCoinBalanceNotify", ProtoPokerRoom.Room.BatchCoinBalanceNotify, 3]

    static ChatHistory:any[] = [null,null,'Room.ChatHistory',ProtoPokerRoom.Room.ChatHistory];
}
